import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { PackPartsFragment } from '../../queries';
import { TextField } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { PackFormData } from '../../pages/PackAdd';

const useStyles = makeStyles({
  label: {
    color: '#fff',
    fontWeight: 600,
  },
});

interface Props {
  isEdit?: boolean;
  packParts?: PackPartsFragment | null;
}

export default function PackPartsList({ packParts, isEdit }: Props) {
  const classes = useStyles();
  const { register } = useFormContext<PackFormData>();

  return (
    <Box p={5}>
      <Grid container spacing={3}>
        {!isEdit && (
          <>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Lock / latch</Typography>
              <Typography>{packParts?.lockLatch ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Door closer</Typography>
              <Typography>{packParts?.closer ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Intumescent strip</Typography>
              <Typography>{packParts?.intumescentStrip ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Hinges</Typography>
              <Typography>{packParts?.hinges ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Handles</Typography>
              <Typography>{packParts?.handles ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Smoke seals</Typography>
              <Typography>{packParts?.smokeSeals ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Drop seal</Typography>
              <Typography>{packParts?.dropSeal ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Cylinder</Typography>
              <Typography>{packParts?.cylinder ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Letterbox</Typography>
              <Typography>{packParts?.letterbox ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Spyhole</Typography>
              <Typography>{packParts?.spyhole ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Threshold strip</Typography>
              <Typography>{packParts?.thresholdStrip ?? '-'}</Typography>
            </Grid>
          </>
        )}
        {isEdit && (
          <>
            <Grid item lg={6} xs={12}>
              <TextField
                name="lockLatch"
                label="Lock / latch"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="closer"
                label="Closer"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="intumescentStrip"
                label="Intumescent strip"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="hinges"
                label="Hinges"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="handles"
                label="Handles"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="smokeSeals"
                label="Smoke seals"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="dropSeal"
                label="Drop seal"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="cylinder"
                label="Cylinder"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="letterbox"
                label="Letterbox"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="spyhole"
                label="Spyhole"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="thresholdStrip"
                label="Threshold strip"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
}
